<template>
    <div>
        <div v-if="!addDiscountToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New Discount" @click="addDiscountToggle = !addDiscountToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.add') + $t('subMenu.salon_menu_discount')}}</span>
            </button>
        </div>
        <div v-if="addDiscountToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('button_link.add') + $t('subMenu.salon_menu_discount')}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <discountForm :isEdit="false" :category="category" @returnDiscountList="returnDiscountList" @submitForm="addDiscount"></discountForm>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!addDiscountToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> -->
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mb-2 align-items-center justify-content-start">
                            <div class="dataTables_filter">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchDiscount" @keypress.enter="searchDiscountItem">
                                    <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0" @click="searchDiscountItem">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6 mb-2"> 
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-tags"></i>
                                        </label>
                                        <multiselect 
                                            :value="selectedSubcategory" 
                                            :options="subCategory" 
                                            track-by="id" label="text" 
                                            :show-labels="false" 
                                            openDirection="below" 
                                            @select="filterBySubCategory">
                                            <span slot="noResult">{{$t('table.no_records')}}</span>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="custom-control custom-checkbox mb-2">
                        <input type="checkbox" class="custom-control-input" id="showEnabled" @change="filterEnable($event)" v-model="isEnable">
                        <label class="custom-control-label" for="showEnabled">{{$t('label.show_enable')}}</label>
                    </div>
                    <a class="link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item" v-for="c in category" :key="c.id">
                                <a :class="{'active': selectedTab == c.id}" class="nav-link" role="tab" @click="filterByCategory(c.id)">{{c.text}}</a>
                            </li>
                        </ul>
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="discountItems" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(title)="data">
                                            <a class="text-primary fw-500 link" @click="showEditDiscount(data.item)">{{data.item.title}}</a>
                                        </template>
                                        <template #cell(price)="data">
                                            {{formatPrice(data.item.price)}}
                                        </template>
                                        <template #cell(category)="data">
                                            {{getCategoryText(data.item.category, category)}}
                                        </template>
                                        <template #cell(subCategory)="data">
                                            {{data.item.folderID == "" ? '-' : getCategoryText(data.item.folderID, subCategory)}}
                                        </template>
                                        <template #cell(isEnable)="data">
                                            <span class="badge" :class="data.item.isEnable == 1 ? 'badge-primary' : 'badge-secondary'">{{data.item.isEnable == 1 ? $t('table.value.enable') : $t('table.value.disable')}}</span>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': editToggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit') + $t('subMenu.salon_menu_discount')}}
                            <small class="m-0 text-muted">{{$t('subMenu.salon_menu_discount')}} - "{{sTitle}}"</small>
                        </h5>
                        <button type="button" class="close" @click="editToggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <discountForm ref="editDiscountForm" :isEdit="true" :category="category" @submitForm="editDiscount" @deleteDiscount="deleteDiscount"></discountForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import DiscountForm from './Discount_Form'
import {formatPrice} from './../../../../assets/js/dashboard/utilities'
import {setReturnData, handleSessionExpired, getSubcategory, getCategoryText, setCategoryLabel}
from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'discountList',
    components:{
        DiscountForm
    },
    data(){
        return{
            type: 'discount',
            isSpinnerShow: false, 
            searchDiscount: "", isEnable: true,
            category: [], selectedTab: "all", 
            subCategories: [], subCategory: [], selectedSubcategory: {},
            discountItems: [], 
            addDiscountToggle: false, editToggleModal: false, 
            sID: 0, sTitle: "",
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "", discountExportData: []
        }
    },
    computed:{
        fields(){
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "itemID", label: this.$i18n.t('table.header.id', {'item': this.$i18n.t('subMenu.salon_menu_discount')}), thClass: 'thead-themed align-middle', sortable: true},
                { key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "price", label: this.$i18n.t('table.header.price'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "category", label: this.$i18n.t('table.header.category'), thClass: 'thead-themed align-middle'},
                { key: "subCategory", label: this.$i18n.t('table.header.subcategory'), thClass: 'thead-themed align-middle', },
                { key: "isEnable", label: this.$i18n.t('table.header.enable'), thClass: 'thead-themed align-middle'},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.id', {'item': this.$i18n.t('subMenu.salon_menu_discount')})).toUpperCase()] = "itemID"
            ret[(this.$i18n.t('table.header.title')).toUpperCase()] = "title"
            ret[(this.$i18n.t('table.header.price')).toUpperCase()] = "price"
            ret[(this.$i18n.t('table.header.category')).toUpperCase()] = "category"
            ret[(this.$i18n.t('table.header.subcategory')).toUpperCase()] = "subCategory"
            ret[(this.$i18n.t('table.header.enable')).toUpperCase()] = "isEnable"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.discountExportData)
            this.setLabel()
            
            var b = Object.assign({}, this.selectedSubcategory)
            this.selectedSubcategory = this.subCategory.filter(obj=> obj.id == b.id)[0]
        }
    },
    methods:{
        formatPrice(p){
            return formatPrice(p);
        },
        getCategoryText(id, arr){
            return getCategoryText(id, arr)
        },
        clearFilter(){
            this.isEnable = true;
            this.searchDiscount = "";
            this.filterByCategory("all");
        },
        returnDiscountList(){
            this.filterDiscountItem(this.selectedTab, this.selectedSubcategory.id, this.isEnable);
            this.addDiscountToggle = this.editToggleModal = false;
        },
        async closeModal(isError){
            if(!isError){
                this.addDiscountToggle = this.editToggleModal = false;
                this.returnDiscountList();
            }
            this.$parent.$parent.isModalShow = false;
        },
        searchDiscountItem(){
            var strFilter = "&search=" + this.searchDiscount;
            this.getDiscountItem(strFilter);

            this.selectedTab = "all";
            this.selectedSubcategory = this.subCategory[0];
            this.isEnable = true;
        },
        async filterByCategory(item){
            this.page = 0;
            this.selectedTab = item;

            var strFilter = item == "all" ? "" : "&category=" + item;
            this.subCategories = await getSubcategory(this, this.type, strFilter);
            this.setLabel()
            this.selectedSubcategory = this.subCategory[0]

            this.filterDiscountItem(this.selectedTab, 0, this.isEnable);
        }, 
        filterBySubCategory(item){
            this.selectedSubcategory = item;
            this.filterDiscountItem(this.selectedTab, this.selectedSubcategory.id, this.isEnable);
        },
        filterEnable(e){
            this.isEnable = e.target.checked ? true : false;
            this.filterDiscountItem(this.selectedTab, this.selectedSubcategory.id, this.isEnable);
        },
        filterDiscountItem(catID, subCatID, isEnable){
            var strCatFilter = catID == "all" ? "" : "&category=" + catID;
            var strSubCatFilter = subCatID == 0 ? "" : "&folderID=" + subCatID;
            var strFilterIsEnable = isEnable ? "&isEnable=1" : "&isEnable=0";
            var strFilter = strCatFilter + strSubCatFilter + strFilterIsEnable;
            this.getDiscountItem(strFilter);
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.filterDiscountItem(this.selectedTab, this.selectedSubcategory.id, this.isEnable);
            }
        },
        async getExportData(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=" + this.type + strFilter
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.items
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            this.discountExportData = result
            this.setExportData(result)
        },
        setExportData(data){
            this.exportData = []

            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_menu_discount`)
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    itemID: data[i].itemID,
                    title: data[i].title,
                    price: data[i].price,
                    category: getCategoryText(data[i].category, this.category),
                    subCategory: data[i].folderID == "" ? '-' : getCategoryText(data[i].folderID, this.subCategory),
                    isEnable: data[i].isEnable == 1 ? this.$i18n.t('table.value.enable') : this.$i18n.t('table.value.disable')
                })
            }
        },
        async getDiscountItem(strFilter){
            let $vm = this;
            let QUERY_STRING =  "?type=" + this.type + "&page=" + this.page + strFilter
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            this.isSpinnerShow = true
            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var retData = setReturnData(response.data.items, response.data.count, $vm.page)
                $vm.discountItems = retData.result;
                $vm.totalEntries = retData.count;
                $vm.totalPage = retData.totalPage;

                $vm.startPage = retData.startPage;
                $vm.endPage = retData.endPage;
                $vm.isSpinnerShow = false;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            await this.getExportData(strFilter)
        },
        addDiscount(data){
            let $vm = this
            this.$axios({
                method: 'post', 
                url: this.$api.MENU_ITEM,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data;
                    var message = "'" + retData.title + "'" + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.add')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                    $vm.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        showEditDiscount(item){
            this.sID = item.itemID
            this.sTitle = item.title
            this.editToggleModal = true;
            this.$refs.editDiscountForm.editDiscountForm(item, this.category);
        },
        editDiscount(data){
            let $vm = this
            let QUERY_STRING = "/" + this.sID + this.$api.UPDATE
            const url =  this.$api.MENU_ITEM + QUERY_STRING;

            this.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var retData = response.data;
                    var message =  "'" + retData.title + "'" + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }else{
                     $vm.$parent.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        deleteDiscount(id, title){
            let $vm = this;
            this.sTitle = title
            this.deleteToggleModal = true;    
            document.getElementById('btnDeleteYes').onclick = function(){
                let QUERY_STRING = "/" + id + "/delete"
                const url =  $vm.$api.MENU_ITEM + QUERY_STRING;
                
                $vm.$axios({
                    method: 'post', 
                    url: url,
                    baseURL: $vm.$axios.defaults.baseURL, 
                    headers: {token: $vm.$session.get('token')},
                })
                .then((response) => {
                    if(response.status == 200){
                        $vm.deleteToggleModal = false;
                        var message = "Discount item deleted successfully."
                        $vm.$parent.$parent.setModal(false, true, message);
                    }
                })
                .catch((err) => {
                    var error = err.response.data.error;
                    if(error == $vm.$api.INVALID_TOKEN){
                        handleSessionExpired();   
                    }
                })
            }
        },
        setLabel(){
            var category = JSON.parse(this.$store.state.category);
            this.category = setCategoryLabel(this, true, this.$i18n.t('label.all', {'item': this.$i18n.t('label.category')}), category.discount)
            this.subCategory = setCategoryLabel(this, false, this.$i18n.t('label.all', {'item': this.$i18n.t('label.subcategory')}), this.subCategories)
        },
    },
    async mounted(){
        let $vm = this;
        $vm.subCategories = await getSubcategory($vm, $vm.type, "");
        $vm.setLabel()
        
        $vm.selectedSubcategory = $vm.subCategory[0]
        $vm.filterDiscountItem("all", 0, true);
        
    }
}
</script>

<style scoped>
.export-button{
    margin-top: -4.15em;
    margin-left: 1em;
}

.nav-link, .link{
    cursor: pointer;
}

.link > i {
    font-size: large;
}

.show{
    display: block;
}
</style>